<template>
    <ac-modal :title="modalTitle" :size-class="'modal-md'" ref="nachaManagerModal">
        <div v-if="widgetReady">
            <ul v-if="nachaFiles.length">
                <li v-for="file in nachaFiles" :key="file">
                    <a @click.prevent="downloadAch(file)">{{file}}</a>
                    <ac-button class="btn btn-blue btn-sm tinyBtn" :action="() => notateNacha(file)">{{!hasNotes(file) ? "Add" : "Edit"}} Note</ac-button>
                     
                    <ac-button class="btn btn-blue btn-sm tinyBtn" >Send</ac-button>
                </li>
            </ul>
            <p v-else>This batch has no records</p>
            
            <div style="margin-top: 15px; text-align: right;">
                <ac-button v-if="canEditBatch && canRerunAch" class="btn btn-green btn-sm" :action="rerunAch">RERUN ACH</ac-button>
                <ac-button class="btn btn-red btn-sm" :action="closeAch">CLOSE</ac-button>
            </div>
        </div>
        <send-nacha-to-bank @refresh="refresh" ref="notateNachaModal">

        </send-nacha-to-bank>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../../../global/framework/api.js";
    import {common} from "../../../../../global/common.js";
    import SendNachaToBank from "./SendNachaToBank.vue";

    export default {
        name: "NachaModal",
        components: {AcModal, SendNachaToBank},
        props: { canRerunAch: { type: Boolean, default: true } },
        data() {
            return {
                widgetReady: false,
                batchId: 0,
                nachaFiles: [],
                nachaNotes: [],
                canEditBatch: false,
            };
        },
        computed: {
            modalTitle() {
                return "ACH File Batch: " + this.batchId;
            },
        },
        methods: {
            async showModal(batchId) {
                this.widgetReady = false;
                this.batchId = batchId; // this.$refs.report.batchId;
                //console.log("NachaModal getAchFiles batchId: ", this.batchId);
                const [nachaFiles, canEditBatch, nachaNotes] = await Promise.all([
                    api.getDataById('PaymentReport', this.batchId, 'NachaFileNames'),
                    api.getDataById('PaymentReport', this.batchId, 'CanEditBatch'),
                    api.getDataById('PaymentReport', this.batchId, 'GetNachaNotes'),
                ]);

                this.nachaFiles = nachaFiles;
                this.canEditBatch = canEditBatch;
                this.nachaNotes = nachaNotes;
                this.$refs.nachaManagerModal.open();
                this.widgetReady = true;
            },
            async downloadAch(fileName) {
                let url = 'PaymentReport/' + this.batchId + '/DownloadNacha';
                url = common.appendUrlParameter(url, 'filename', fileName);
                //console.log("NachaModal downloadAch url: ", url);
                common.downloadFile(url, fileName);
            },
            async notateNacha(fileName) {
                this.$refs.notateNachaModal.showModal(this.batchId, fileName);
            },
            async rerunAch() {
                //console.log("NachaModal rerunAch batchId: ", this.batchId);
                await api.postWithId('PaymentReport', this.batchId, 'RerunNacha');
                this.showModal(this.batchId);
            },
            closeAch() {
                this.$refs.nachaManagerModal.close();
            },
            hasNotes(fileName) {
                return this.nachaNotes.map(x => x.fileName).includes(fileName);
            },
            refresh() {
                this.closeAch();
                this.showModal(this.batchId);
            }
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }     
    .tinyBtn {
        line-height: normal;
        border: 0px;
        padding: 2px;
        margin-bottom: 3px;
    }
</style>